import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';
import { buildVariables, GET_WEBHOOK_DELIVERY_LOGS } from './webhook-delivery-logs-query-builder';

export default function useLazyQueryWebhookDeliveryLogs({ webhookConfigId, filters, ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(GET_WEBHOOK_DELIVERY_LOGS, {
    context: { permission: permissions.readWebhookDeliveryLogs },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  const getWebhookDeliveryLogs = pagination => {
    const variables = buildVariables({ pagination, webhookConfigId, filters });
    return executeQuery({ variables });
  };

  return [getWebhookDeliveryLogs, { ...transformData(data), ...rest }];
}

function transformData(data) {
  if (!data) {
    return {
      data: [],
      pagination: { count: null },
    };
  }

  const { webhookDeliveryLogs, webhookDeliveryLogsAggregate } = data;

  return {
    data: webhookDeliveryLogs,
    pagination: { count: webhookDeliveryLogsAggregate.aggregate.count },
  };
}
